import { List,Record } from "immutable";

import { DateFormatIdentifiers, ThousandSeparatorFormatNames } from "../../../../constants/dateFormats";
import { DateOrderIdentifiers } from "../../../../constants/dateOrders";
import { TimeFormatIdentifiers } from "../../../../constants/timeFormats";
import calendarTypes from "../../../calendarTypes";
import createFromJS from "../../../createFromJS";

export const CalendarRecord = Record({
  // components of calendar
  eras: List(),
  months: List(),
  weekdays: List(),
  // calculation settings
  ignoreEras: false,
  leapCycles: List([4, 100, 400]),
  hoursInDay: 24,
  weekdayIndexAtZero: 0,
  // display format settings
  zeroDateTimestamp: null,
  dateFormat: DateFormatIdentifiers.Medium,
  timeFormat: TimeFormatIdentifiers.Twelve,
  dateOrder: DateOrderIdentifiers.DayMonthYear,
  dateFormatIncludesDayName: true,
  defaultToModernCentury: true,
  calendarType: calendarTypes.CALENDAR_TYPE_DATE_TIME,
  thousandSeparatorFormat: ThousandSeparatorFormatNames.Comma,
  overrideNowTimestamp: null
});

const data = {
  objects: {
    leapCycles: "List"
  },
  collections: {
    eras: "EraRecord",
    weekdays: "WeekdayRecord",
    months: "MonthRecord"
  }
};
createFromJS.registerCallback("CalendarRecord", createFromJS.createNestedCallback(CalendarRecord, data));
